import React from 'react'
import LeftBox from './LeftBox'
import RightBox from './RightBox'

const Boxcomponents = () => {
  return (
    <div className="box">
     <LeftBox/>
     <RightBox/>
      
    </div>
  )
}

export default Boxcomponents